import './../../css/mk-brand.css';
import one from '../../media/jake-al-dente.jpg'
import two from '../../media/jet-coltello.jpeg'
import three from '../../media/mk-Spicy.png'
import four from '../../media/Technochef1.png'
import six from '../../media/Reverse Sear.png'
import five from '../../media/Beyjaa.png'
import {useState, useEffect} from "react";
import AlphaVerifi from "../../media/partners/alpha-verifi-logo.jpeg";


function OurTeamPanel() {
    useEffect(() => {}, );
    return (
        <div id="our-team-panel" className="text-white">
            <div className="container mx-auto mt-4 ">
                <div className="flex flex-col text-center w-full ">
                    <h1 className="flex justify-center">
                    <h1 className="text-4xl text-white font-extrabold ">mK</h1>
                    <h1 className="text-4xl  font-extrabold text-brand">Executive</h1>
                        <h1 className="text-4xl text-gray-500 font-extrabold">&nbsp;Chefs</h1>
                    </h1>
                    <p className="lg:w-2/3  text-2xl mx-auto">meet our core team</p>
                </div>
                <div className="border border-brand" />
                <div className="text-brand-text text-2xl text-right cursor-pointer hover:font-bold">
                    <a href="https://www.alpha-verifi.com/metakitchen">
                        Fully Doxxed by Alpha Labs
                    </a>
                </div>
                <div className="flex flex-wrap m-4  rounded-lg">
                    <div className="p-4 lg:w-1/2">
                        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left bg-zinc-800 rounded-lg p-2 ">
                            <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={one}/>
                            <div className="flex-grow sm:pl-8 mb-5">
                                <h2 className="title-font font-medium text-lg text-brand">Jake al Dente</h2>
                                <h3 className="text-gray-400 mb-3">CEO</h3>
                                <p className="mb-4">With a deep knowledge of private and public market mechanics and years of investment experience Jake leads the team with a hands on approach that is full of energy and insight. His favorite foods are Pasta and Pizza.</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 lg:w-1/2">
                        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left bg-zinc-800 rounded-lg p-2">
                            <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={two}/>
                                <div className="flex-grow sm:pl-8">
                                    <h2 className="title-font font-medium text-lg text-brand">Jet Coltello</h2>
                                    <h3 className="text-gray-400 mb-3">CFO, Treasurer, and professor of Tokenomics</h3>
                                    <p className="mb-4">Inspired by the blockchain Coltello lives and breaths crypto currency. Coltello ensures that the required resources are available and provides top level execution when needed. Coltello specializes in behavioral economics and is responsible for governing all tokenomics. His favorite food is nasi lemak. </p>
                                </div>
                        </div>
                    </div>

                    <div className="p-4 lg:w-1/2">
                        <div
                            className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left bg-zinc-800 rounded-lg p-2">
                            <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={three}/>
                                <div className="flex-grow sm:pl-8">
                                    <h2 className="title-font font-medium text-lg text-brand">Chef Mk Spicy</h2>
                                    <h3 className="text-gray-400 mb-3">Game Designer, Product Manager, and Sr. Software Developer</h3>
                                    <p className="mb-4">Over 30 years of professional software development. Chef Spicy brings a wealth of successful software development and business experience along with a track record of highly creative game design. Spicy is OG, back in the day Mk Spicy's first game was designed and released on a Commodore PET (think prehistoric). Above all else, Mk Spicy enjoys everything  with Jalapeños.</p>
                                </div>
                        </div>
                    </div>
                    <div className="p-4 lg:w-1/2">
                        <div
                            className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left bg-zinc-800 rounded-lg p-2">
                            <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={four}/>
                                <div className="flex-grow sm:pl-8 mb-5">
                                    <h2 className="title-font font-medium text-lg text-brand">Technochef</h2>
                                    <h3 className="text-gray-400 mb-3">Blockchain Architect and Sr. Software Developer</h3>
                                    <p className="mb-4">TC is a Sr. Software Developer and Architect with extensive experience in web applications, web performance, and smart game development. He enjoys firing up the grill for some mean burgers.</p>
                                </div>
                        </div>
                    </div>
                    <div className="p-4 lg:w-1/2">
                        <div
                            className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left bg-zinc-800 rounded-lg p-2">
                            <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={five}/>
                            <div className="flex-grow sm:pl-8 mb-5">
                                <h2 className="title-font font-medium text-lg text-brand">Beyjaa</h2>
                                <h3 className="text-gray-400 mb-3">Artist</h3>
                                <p className="mb-4">Designer and lead artist for metakitchen. With the background in 3D modelling and digital art freelance. Student of Industrial design and engineering manufacturing product design. Jaa is a Sushi lover in particular Tuna sashimi!</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 lg:w-1/2">
                        <div
                            className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left bg-zinc-800 rounded-lg p-2">
                            <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={six}/>
                            <div className="flex-grow sm:pl-8 mb-5">
                                <h2 className="title-font font-medium text-lg text-brand">Reverse Sear</h2>
                                <h3 className="text-gray-400 mb-3">Head of Marketing, Community Manager</h3>
                                <p className="mb-4">With a successful background in real estate investments, digital marketing and sales, Reverse Sear knows how bring a project and a community to life.
                                    His favourite food to cook at home is steak and frites.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a className="p-8" href="https://www.alpha-verifi.com/metakitchen">
                <img className="mx-auto w-24 rounded-lg" alt="Alpha Verifi link" src={AlphaVerifi} />
            </a>
        </div>
    );
}

export default OurTeamPanel;